import React, { createContext, useContext, useState } from 'react'

const PendingPaySlipRequestContext = createContext();

export default function PendingPaySlipRequestProvider({ children }) {
    const [pendingPayslipCount, setPendingPayslipCount] = useState(0);

    const updatePendingPayslipCount = (newCount) => {
    setPendingPayslipCount(newCount);
  };

  return (
    <PendingPaySlipRequestContext.Provider value={{ pendingPayslipCount, updatePendingPayslipCount }}>
      {children}
    </PendingPaySlipRequestContext.Provider>
  )
}

export const usePendingPayslipRequests = () => useContext(PendingPaySlipRequestContext);
